import Vue from "vue";
import Vuex from "vuex";
import { LOGIN_USER_INFO, LOGIN_TOKEN_KEY } from "@/utils/constants";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem(LOGIN_USER_INFO) || "{}") || {},
    isLogin: localStorage.getItem("isLogin") === "true" || false,
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload || {};
      if (payload) {
        localStorage.setItem(LOGIN_USER_INFO, JSON.stringify(payload));
      } else {
        localStorage.removeItem(LOGIN_USER_INFO);
      }
    },
    SET_LOGIN(state, value) {
      state.isLogin = value;
      localStorage.setItem("isLogin", value);
    },
  },
  actions: {
    login({ commit }, updata = {}) {
      commit("SET_LOGIN", true);
      if (updata.userinfo) {
        commit("setUserInfo", updata.userinfo);
      }
      if (updata.token) {
        localStorage.setItem(LOGIN_TOKEN_KEY, updata.token);
      }
    },
    logout({ commit }) {
      commit("SET_LOGIN", false);
      commit("setUserInfo", null); // 清空 userInfo
      localStorage.removeItem(LOGIN_TOKEN_KEY); // 移除 token
    },
  },
  modules: {},
  getters: {},
});